import React from 'react';

const EnvVarsFeaturesContext = React.createContext({
  features: {},
  envVars: {},
  contentBlocks: [],
});

export default EnvVarsFeaturesContext;
